var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container " },
    [
      _c(
        "BoxWrap",
        { attrs: { title: _vm.$t("SRStoreList.BoxWrap.manage") } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "FPermission",
                  rawName: "v-FPermission",
                  value: { pageName: _vm.pageName, list: ["LIST"] },
                  expression: "{pageName, list: ['LIST']}",
                },
              ],
              staticClass: "action-container",
            },
            [
              _c(
                "el-form",
                {
                  attrs: { size: "small", inline: "", "label-position": "top" },
                },
                [
                  _c(
                    "el-row",
                    { staticClass: "row-bg", attrs: { type: "flex" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "SRStoreList.form.customerNumber"
                                ),
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("common.pleaseInput"),
                                  autocomplete: "off",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchVal.rtlSapId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchVal, "rtlSapId", $$v)
                                  },
                                  expression: "searchVal.rtlSapId",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SRStoreList.form.storeName"),
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("common.pleaseInput"),
                                  autocomplete: "off",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchVal.rtlFullName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchVal, "rtlFullName", $$v)
                                  },
                                  expression: "searchVal.rtlFullName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SRStoreList.form.RTMType"),
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    placeholder: _vm.$t("common.pleaseSelect"),
                                  },
                                  model: {
                                    value: _vm.searchVal.rtlRtmCategory,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.searchVal,
                                        "rtlRtmCategory",
                                        $$v
                                      )
                                    },
                                    expression: "searchVal.rtlRtmCategory",
                                  },
                                },
                                _vm._l(
                                  _vm.lookupList["STORE_RTM_TYPE"],
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.code,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "SRStoreList.form.retailStoreCategory"
                                ),
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    multiple: "",
                                    clearable: "",
                                    placeholder: _vm.$t("common.pleaseSelect"),
                                  },
                                  model: {
                                    value: _vm.searchVal.retailerTypeList,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.searchVal,
                                        "retailerTypeList",
                                        $$v
                                      )
                                    },
                                    expression: "searchVal.retailerTypeList",
                                  },
                                },
                                _vm._l(
                                  _vm.lookupList["STORE_CATEGORY"],
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.code,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "SRStoreList.form.provinceCityDistrict"
                                ),
                              },
                            },
                            [
                              _c("el-cascader", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "DAStoreList.form.cascaderPlaceholder"
                                  ),
                                  options: _vm.regionOptions,
                                  "collapse-tags": "",
                                  clearable: "",
                                  props: {
                                    multiple: true,
                                    checkStrictly: false,
                                    value: "label",
                                  },
                                },
                                on: {
                                  clear: _vm.pcdClearEvent,
                                  change: _vm.pcdChangeEvent,
                                },
                                model: {
                                  value: _vm.region,
                                  callback: function ($$v) {
                                    _vm.region = $$v
                                  },
                                  expression: "region",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SRStoreList.form.address"),
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  placeholder: _vm.$t("common.pleaseInput"),
                                  autocomplete: "off",
                                },
                                model: {
                                  value: _vm.searchVal.rtlAddress,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchVal, "rtlAddress", $$v)
                                  },
                                  expression: "searchVal.rtlAddress",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SRStoreList.form.shopBrandType"),
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    placeholder: _vm.$t("common.pleaseSelect"),
                                  },
                                  model: {
                                    value: _vm.searchVal.signBoardBrand,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.searchVal,
                                        "signBoardBrand",
                                        $$v
                                      )
                                    },
                                    expression: "searchVal.signBoardBrand",
                                  },
                                },
                                _vm._l(
                                  _vm.lookupList["STORE_SIGN_BRAND_TYPE"],
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.code,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "SRStoreList.form.TTPSigningVolumeGY"
                                ),
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    placeholder: _vm.$t("common.pleaseSelect"),
                                  },
                                  model: {
                                    value: _vm.searchVal.tppGySign,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.searchVal, "tppGySign", $$v)
                                    },
                                    expression: "searchVal.tppGySign",
                                  },
                                },
                                _vm._l(
                                  _vm.lookupList["TPP_SIGN_ASC_GY"],
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.code,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "SRStoreList.form.TTPSigningVolumeCP"
                                ),
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    placeholder: _vm.$t("common.pleaseSelect"),
                                  },
                                  model: {
                                    value: _vm.searchVal.tppCpSign,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.searchVal, "tppCpSign", $$v)
                                    },
                                    expression: "searchVal.tppCpSign",
                                  },
                                },
                                _vm._l(
                                  _vm.lookupList["TPP_SIGN_ASC_CP"],
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.code,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "SRStoreList.form.lastPurchaseTime"
                                ),
                              },
                            },
                            [
                              _c("FormDateRange", {
                                attrs: {
                                  "target-form": _vm.searchVal,
                                  "key-list": [
                                    "lastPurchaseStartTime",
                                    "lastPurchaseEndTime",
                                  ],
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SRStoreList.form.lastVisitTime"),
                              },
                            },
                            [
                              _c("FormDateRange", {
                                attrs: {
                                  "target-form": _vm.searchVal,
                                  "key-list": [
                                    "lastVisitStartTime",
                                    "lastVisitEndTime",
                                  ],
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          directives: [
                            {
                              name: "FPermission",
                              rawName: "v-FPermission",
                              value: {
                                pageName: _vm.pageName,
                                list: ["SEARCH"],
                              },
                              expression: "{pageName, list: ['SEARCH']}",
                            },
                          ],
                          attrs: { span: 7 },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("SRStoreList.form.SRNO") },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("common.pleaseInput"),
                                  autocomplete: "off",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchVal.empNo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchVal, "empNo", $$v)
                                  },
                                  expression: "searchVal.empNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          directives: [
                            {
                              name: "FPermission",
                              rawName: "v-FPermission",
                              value: {
                                pageName: _vm.pageName,
                                list: ["SEARCH"],
                              },
                              expression: "{pageName, list: ['SEARCH']}",
                            },
                          ],
                          attrs: { span: 7 },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SRStoreList.form.SRName"),
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("common.pleaseInput"),
                                  autocomplete: "off",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchVal.empName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchVal, "empName", $$v)
                                  },
                                  expression: "searchVal.empName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SRStoreList.form.storeContact"),
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("common.pleaseInput"),
                                  autocomplete: "off",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchVal.contactsNameOne,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.searchVal,
                                      "contactsNameOne",
                                      $$v
                                    )
                                  },
                                  expression: "searchVal.contactsNameOne",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SRStoreList.form.isBaiLian"),
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    placeholder: _vm.$t("common.pleaseSelect"),
                                  },
                                  model: {
                                    value: _vm.searchVal.isBaiLian,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.searchVal, "isBaiLian", $$v)
                                    },
                                    expression: "searchVal.isBaiLian",
                                  },
                                },
                                _vm._l(
                                  _vm.lookupList["Y_OR_N"],
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.code,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SRStoreList.table.gasnFlag"),
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    placeholder: _vm.$t("common.pleaseSelect"),
                                  },
                                  model: {
                                    value: _vm.searchVal.gasnFlag,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.searchVal, "gasnFlag", $$v)
                                    },
                                    expression: "searchVal.gasnFlag",
                                  },
                                },
                                _vm._l(
                                  _vm.lookupList["GASN_EXPIRATION_STORE"],
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.code,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer-right" }, slot: "footer-right" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["LIST"] },
                      expression: "{pageName, list: ['LIST']}",
                    },
                  ],
                  attrs: { size: "small", icon: "el-icon-refresh" },
                  on: { click: _vm.resetData },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("common.reset")) + "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["LIST"] },
                      expression: "{pageName, list: ['LIST']}",
                    },
                  ],
                  staticClass: "t-search-btn",
                  attrs: { size: "small", icon: "el-icon-search" },
                  on: { click: _vm.searchData },
                },
                [_vm._v(_vm._s(_vm.$t("common.search")) + "\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "BoxWrap",
        {
          staticClass: "main-table-container",
          attrs: { title: _vm.$t("SRStoreList.BoxWrap.list") },
        },
        [
          _c("div", { attrs: { slot: "header-right" }, slot: "header-right" }, [
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "FPermission",
                        rawName: "v-FPermission",
                        value: { pageName: _vm.pageName, list: ["NEW_STORE"] },
                        expression: "{pageName, list: ['NEW_STORE']}",
                      },
                    ],
                    attrs: { size: "small" },
                    on: { click: _vm.onAddStore },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("SRStoreList.common.addStore")) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-dropdown",
                  {
                    directives: [
                      {
                        name: "FPermission",
                        rawName: "v-FPermission",
                        value: { pageName: _vm.pageName, list: ["EXPORT"] },
                        expression: "{pageName, list: ['EXPORT']}",
                      },
                    ],
                    attrs: { size: "medium" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "small",
                          loading: _vm.btnLoading,
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("SRStoreList.btn.export"))
                        ),
                        _c("em", {
                          staticClass: "el-icon-arrow-down el-icon--right",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      [
                        _c(
                          "el-dropdown-item",
                          {
                            staticClass: "t-square-btn t-green-btn ",
                            attrs: {
                              type: "primary",
                              size: "small",
                              circle: "",
                            },
                            nativeOn: {
                              click: function ($event) {
                                _vm.downloadExcel(
                                  "STORE_INFO",
                                  _vm.$t("SRStoreList.export.storeInfo")
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SRStoreList.export.storeInfo")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-item",
                          {
                            staticClass: "t-square-btn t-green-btn",
                            attrs: {
                              type: "primary",
                              size: "small",
                              circle: "",
                            },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.showMonthSelect("TIRE_SALES")
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SRStoreList.export.otherInfo")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-item",
                          {
                            staticClass: "t-square-btn t-green-btn",
                            attrs: {
                              type: "primary",
                              size: "small",
                              circle: "",
                            },
                            nativeOn: {
                              click: function ($event) {
                                _vm.downloadExcel(
                                  "TRAINING",
                                  _vm.$t("SRStoreList.export.trainRecord")
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SRStoreList.export.trainRecord")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-item",
                          {
                            staticClass: "t-square-btn t-green-btn",
                            attrs: {
                              type: "primary",
                              size: "small",
                              circle: "",
                            },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.showMonthSelect("VISIT_REPORT")
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SRStoreList.export.visitRecord")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-item",
                          {
                            staticClass: "t-square-btn t-green-btn",
                            attrs: {
                              type: "primary",
                              size: "small",
                              circle: "",
                            },
                            nativeOn: {
                              click: function ($event) {
                                _vm.downloadExcel(
                                  "KPI_DATA",
                                  _vm.$t("SRStoreList.export.KPIData")
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SRStoreList.export.KPIData")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-item",
                          {
                            staticClass: "t-square-btn t-green-btn",
                            attrs: {
                              type: "primary",
                              size: "small",
                              circle: "",
                            },
                            nativeOn: {
                              click: function ($event) {
                                _vm.downloadExcel(
                                  "DOORSTEP_PHOTO",
                                  _vm.$t("SRStoreList.export.storeLogoInfo")
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("SRStoreList.export.storeLogoInfo")
                              ) + "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-item",
                          {
                            staticClass: "t-square-btn t-green-btn",
                            attrs: {
                              type: "primary",
                              size: "small",
                              circle: "",
                            },
                            nativeOn: {
                              click: function ($event) {
                                _vm.downloadExcel(
                                  "FEEDBACK",
                                  _vm.$t("SRStoreList.export.feedback")
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SRStoreList.export.feedback")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "rtlSapId",
                  label: _vm.$t("SRStoreList.table.customerNumber"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rtlFullName",
                  label: _vm.$t("SRStoreList.table.storeName"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("SRStoreList.table.RTMType"),
                  align: "left",
                  "show-overflow-tooltip": "",
                  "min-width": "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                (_vm.lookupList["STORE_RTM_TYPE_MAPPING"] &&
                                  _vm.lookupList["STORE_RTM_TYPE_MAPPING"][
                                    scope.row.rtlRtmCategory
                                  ]) ||
                                  scope.row.rtlRtmCategory
                              ) +
                              "\n          "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("SRStoreList.table.retailStoreCategory"),
                  "min-width": "140",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                (_vm.lookupList["STORE_CATEGORY_MAPPING"] &&
                                  _vm.lookupList["STORE_CATEGORY_MAPPING"][
                                    scope.row.retailerType
                                  ]) ||
                                  scope.row.retailerType
                              ) +
                              "\n          "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rtlRegion",
                  label: _vm.$t("SRStoreList.table.province"),
                  align: "left",
                  "min-width": "180",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rtlCity",
                  label: _vm.$t("SRStoreList.table.city"),
                  align: "left",
                  "min-width": "180",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rtlDistrict",
                  label: _vm.$t("SRStoreList.table.area"),
                  align: "left",
                  "min-width": "180",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rtlAddress",
                  label: _vm.$t("SRStoreList.table.address"),
                  align: "left",
                  "min-width": "260",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "empNo",
                  label: _vm.$t("SRStoreList.table.SRNO"),
                  align: "left",
                  "min-width": "180",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "empName",
                  label: _vm.$t("SRStoreList.table.SRName"),
                  align: "left",
                  "min-width": "180",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "tppGySign",
                  label: _vm.$t("SRStoreList.table.TTPSigningVolumeGY"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "tppCpSign",
                  label: _vm.$t("SRStoreList.table.TTPSigningVolumeCP"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "signBoardBrand",
                  label: _vm.$t("SRStoreList.table.shopBrandType"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "contactsNameOne",
                  label: _vm.$t("SRStoreList.table.storeContact"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("SRStoreList.table.gasnFlag"),
                  align: "left",
                  "show-overflow-tooltip": "",
                  "min-width": "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                (_vm.lookupList[
                                  "GASN_EXPIRATION_STORE_MAPPING"
                                ] &&
                                  _vm.lookupList[
                                    "GASN_EXPIRATION_STORE_MAPPING"
                                  ][scope.row.gasnFlag]) ||
                                  scope.row.gasnFlag
                              ) +
                              "\n          "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("SRStoreList.table.action"),
                  fixed: "right",
                  width: "140",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-button", {
                          directives: [
                            {
                              name: "FPermission",
                              rawName: "v-FPermission",
                              value: {
                                pageName: _vm.pageName,
                                list: ["DETAIL"],
                              },
                              expression: "{pageName, list: ['DETAIL']}",
                            },
                          ],
                          staticClass: "t-square-btn t-green-btn",
                          attrs: {
                            type: "danger",
                            size: "mini",
                            icon: "el-icon-view",
                            circle: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onView(scope.row)
                            },
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total>0",
              },
            ],
            attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
            on: {
              "update:page": function ($event) {
                _vm.currPage = $event
              },
              "update:limit": function ($event) {
                _vm.limit = $event
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("AddEditStoreModel", {
        ref: "addEditStoreModel",
        attrs: {
          "region-options": _vm.regionOptions,
          "opt-config": _vm.optConfig,
        },
        on: { refresh: _vm.fetchData },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            top: "30vh",
            title: _vm.exportTitle,
            visible: _vm.monthVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.monthVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SRStoreList.form.monthRange") } },
                [
                  _c(
                    "div",
                    { staticStyle: { width: "400px" } },
                    [
                      _c("FormDateRange", {
                        attrs: {
                          "range-type": "monthrange",
                          valueformat: "yyyyMM",
                          "target-form": _vm.searchVal,
                          "start-placeholder": _vm.$t(
                            "SRStoreList.common.startMonthHolder"
                          ),
                          "end-placeholder": _vm.$t(
                            "SRStoreList.common.endMonthHolder"
                          ),
                          "key-list": [
                            "planTaskStartMonth",
                            "planTaskEndMonth",
                          ],
                          "picker-options": _vm.pickerOptions,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: !(
                      _vm.searchVal.planTaskStartMonth &&
                      _vm.searchVal.planTaskEndMonth
                    ),
                    loading: _vm.btnLoading,
                  },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.reportExport($event)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("common.export")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }